import React, { Component } from 'react';
import Icon from 'components/common/Icon';
import isObject from 'lodash/isObject';

export default class PageList extends Component {

  render() {
    const { page, onSelect, drawDivider, showChevron } = this.props;

    if (!page || !page.id) {
      return <div></div>;
    }

    let description;

    let displayClass = 'data';
    let itemClass = 'list-item clickable';

    if (page.description && page.description.length) {
      description = (
        <div className="subtext">
          <span key="page-description" dangerouslySetInnerHTML={{ __html: page.description }} />
        </div>
      );
    } else {
      itemClass += ' thin';
    }

    /* eslint react/jsx-no-bind: 0 */
    const renderItem = () => (
      <div className={itemClass} onClick={onSelect.bind(null, page)}>
        <div className="inner">
          <div className={displayClass}>
            {page.name}
            {description}
          </div>
        </div>

        {showChevron && (
          <Icon icon="arrow" className="link-indicator" />
        )}

        {drawDivider && (
          <div className="divider"></div>
        )}
      </div>
    );

    return (
      <span>
        {renderItem()}
      </span>
    );
  }
}

/* eslint no-console: ["error", { allow: ["info"] }] */
PageList.defaultProps = {
  onSelect: (page) => console.info('Page selected', page.name),
};



// WEBPACK FOOTER //
// ./src/app/components/calendar/PageListItem.js